// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__CPZR_","file":"styles_file__1VTGl"};